module.exports = __webpack_public_path__ + "img/commentuser.d5a3d439.svg";